import * as colors from './colors'

export const rawStyles = {
    contracted: {
        gridRowEnd: 'analysisPanel',
    },
    mapToolbar: {
        alignItems: 'stretch',
        backgroundColor: colors.offwhite,
        boxShadow: '2px 0 1px 1px rgba(0,0,0,0.2)',
        composes: 'aboveMap',
        display: 'flex',
        flexBasis: '0',
        flexDirection: 'column',
        gridColumnStart: 'toolbar',
        gridColumnEnd: 'right',
        gridRowStart: 'subHeader',
        gridRowEnd: 'bottom',
    },
    mapToolbarBottom: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
    },
    mapToolbarTitleBar: {
        backgroundColor: colors.secondaryTwo,
        color: colors.white,
        flex: '0 1',
        maxWidth: '100%',
        lineHeight: '44px',
        margin: '0',
        overflow: 'inherit',
        textAlign: 'center',
    },
    mapToolbarTop: {
        flexBasis: '0',
        flexGrow: '1',
        overflowY: 'hidden',
    },
    noBoxShadow: {
        boxShadow: 'none',
    },
    mapToolbarSpacer: {
        backgroundColor: colors.secondaryTwo,
        color: '#0c6c79',
        height: '44px',
    },
    spacerTransparent: {
        height: '44px',
    },
}

export default rawStyles
